import { type DeselectAllEvent } from '../events/types.ts';
import { type SelectionState } from '../state/types.ts';

import { type ReducerResponse } from './types.ts';

/**
 * Clears all selections and resets mode to idle.
 */
export function deselectAllReducer(
  state: SelectionState,
  event: DeselectAllEvent
): ReducerResponse {
  return {
    delta: {
      kind: 'selectionReplaced',
      source: event.source,
      selections: [],
      focusChange: {
        prev: state.focusedCell,
        next: null
      }
    },
    next: {
      ...state,
      mode: 'idle',
      focusedCell: null,
      selections: [],
      lastInteractionSource: event.source
    }
  };
}
